const getters = {
  getPercentageOfLoads: state => {
    return state.percentageOfLoads
  },

  getCompanyTypes: state => {
    return state.companyTypes
  },

  getRoles: state => {
    return state.roles
  },

  getEnergyTypes: state => {
    return state.energyTypes
  },

  getEnergyTypesWithNull: state => {
    return [{name: 'все', id: null, publicCode: null}, ...state.energyTypes]
  },

  getNodeTypes: state => {
    return state.nodeTypes
  },

  getNodeTypesWithNull: state => {
    return [{name: 'все', id: null, publicCode: null}, ...state.nodeTypes]
  },

  getEnergyMeterTypes: state => {
    return state.energyMeterTypes
  },

  getTransportTechnologies: state => {
    return state.transportTechnologies
  },

  getLogActions: state => {
    return state.logActions
  },

  getLogObjects: state => {
    return state.logObjects
  },

  getRecordTypes: state => {
    return state.recordTypes
  },

  getPeriodTypes: state => {
    return state.periodTypes
  },

  /*getProjectGroups: state => {
    return state.projectGroups
  },*/

  getProjectTypes: state => {
    return state.projectTypes
  },

  getExportProvidersTypes: state => {
    return state.exportProvidersTypes
  },

  getTaskTypes: state => {
    return state.taskTypes
  },
  
  getPaperActTypes: state => {
    return state.paperActTypes
  },
  
  getApkMeterMarks: state => {
    return [
      { name: 'По гарантии' },
      { name: 'Без регистрации' },
      { name: 'Водоканал' },
      { name: 'Замена по факту' },
      { name: 'установка' },
      { name: 'аква/замена' },
      { name: 'течь' },
      { name: 'Не в работу' },
      { name: 'поверка' },
      { name: 'ввод' },
      { name: 'отсутствует' },
      { name: 'единственный' },
      { name: 'гор.' },
      { name: 'АкваС/опломбировка' },
      { name: 'пломбу' },
      { name: 'сняли' },
    ]
  }
}

export default getters